export default {"src":"/_next/static/media/new-plants.4820039e.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};